import { css } from '@emotion/react';
import type {
  HTMLAttributes,
  PropsWithChildren, ReactElement,
} from 'react';
import type { Theme } from '~/_shared/themes/theme.model';

const pillStyles = (theme: Theme) => css({
  borderRadius: 1000,
  paddingInline: 10,
  paddingBlock: 5,
  fontSize: 12,
  whiteSpace: 'nowrap',
  backgroundColor: theme.backgroundColors.primary,
  color: theme.textColors.primary,
});

export type PillProps = PropsWithChildren<{
  backgroundColor?: string;
  textColor?: string;
}>;

export const Pill = ({
  children,
  textColor,
  backgroundColor,
  ...restProps
}: PillProps & HTMLAttributes<HTMLDivElement>): ReactElement => (
  <div
    css={pillStyles}
    style={{ backgroundColor, color: textColor }}
    {...restProps}
  >
    {children}
  </div>
);
